import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FacilityLocationsMaterialModule } from './facility-locations-material-modules.module';
import { FacilityLocationsComponent } from './facility-locations.component';

@NgModule({
    imports: [CommonModule, FacilityLocationsMaterialModule, ReactiveFormsModule, FormsModule],
    declarations: [FacilityLocationsComponent],
    exports: [FacilityLocationsComponent],
})
export class FacilityLocationsModule {}
